<script>
  
  import Constantes from "../../Classes/Constantes";
  import Navigate from "../../Classes/Navigate";
   let navi = new Navigate();
  function verAssessoria() {
    navi.goTo(Constantes.tela_assessorias);
  }

  function verMeusPlanos() {
    navi.goTo(Constantes.tela_exibe_plano_corrida);
  }

  function verMenu() {
    navi.goTo(Constantes.tela_menu);
  }
</script>

<main class="container">
  <br />
  <br />
  <br />
  <br />
  <section class="intro">
    <h1>Bem-vindo ao FitPace!</h1>
    <p>Sua ferramenta definitiva para treinos personalizados.</p>
    <p>
      No FitPace, os professores podem criar e monitorar planos de treino
      personalizados para seus alunos. Esteja você correndo ou treinando na
      academia, aqui você encontra uma maneira organizada e eficiente de
      acompanhar seu progresso.
    </p>
  </section>

  <section class="benefits">
    <div>
      <h2>Para Treinadores:</h2>
      <ul>
        <li>
          Gerencie planos de treino para um grande número de alunos de maneira
          eficiente.
        </li>
        <li>Acompanhe a evolução dos seus alunos em tempo real.</li>
      </ul>
    </div>
    <div>
      <h2>Para Alunos:</h2>
      <ul>
        <li>Tenha seu treino sempre à mão, organizado e personalizado.</li>
        <li>
          Mantenha contato direto com seu treinador e alcance seus objetivos.
        </li>
      </ul>
    </div>
  </section>

  <section class="actions">
    <button on:click={verAssessoria}>Assessorias</button>
    <button on:click={verMeusPlanos}>Meu plano de treino</button>
    <button on:click={verMenu}>Menu</button>
  </section>
</main>

<style>
  .container {
    text-align: center;
    padding: 20px;
    color: white;
    background-image: url("/img/pista.jpg");
    background-size: cover; /* Para cobrir toda a tela */
    background-position: center; /* Para centralizar a imagem */
  }
  .intro,
  .benefits,
  .actions {
    background-color: rgba(0, 0, 0, 0.6); /* Fundo preto semi-transparente */
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
  }
  .benefits {
    display: flex;
    justify-content: space-around;
    margin-bottom: 30px;
  }
  .benefits div {
    width: 45%;
  }
  .actions button {
    width: 80%;
    padding: 15px;
    margin: 10px 0;
    font-size: 18px;
    cursor: pointer;
    background-color: #28a745; /* Cor do botão */
    color: white;
    border: none;
    border-radius: 5px;
    transition: background-color 0.3s;
  }
  .actions button:hover {
    background-color: #218838; /* Cor do botão ao passar o mouse */
  }
  @media (max-width: 768px) {
    .benefits {
      flex-direction: column;
      align-items: center;
    }
    .benefits div {
      width: 100%;
      margin-bottom: 20px;
    }
    .actions button {
      width: 100%;
    }
  }
</style>
